<template>
  <div class="vx-row flex flex-col">
    <div class="vx-col w-full">
      <vs-card>
        <div slot="header">
          <h3>{{service.name}}</h3>
        </div>
        <div class="flex flex-col">
          <vs-button
            @click="$router.push({name: 'services-edit',params:{id: service.id}})"
            color="primary"
            type="filled"
            icon-pack="feather"
            icon="icon-edit"
            class="mb-4 self-end"
            size="medium"
          >Edit Layanan</vs-button>
          <vs-table :data="[1]">
            <template slot="thead">
              <th style="width: 200px;"></th>
              <th style="width: 20px;"></th>
              <th></th>
            </template>
            <tbody>
              <tr>
                <td>Nama Layanan</td>
                <td>:</td>
                <td>{{service.name}}</td>
              </tr>
              <tr>
                <td>Kode Layanan</td>
                <td>:</td>
                <td>{{service.service_code}}</td>
              </tr>
              <tr>
                <td>Status Layanan</td>
                <td>:</td>
                <td>{{service.status == 1 ? 'Aktif' : 'Tidak Aktif'}}</td>
              </tr>
              <tr>
                <td>Status Antrian</td>
                <td>:</td>
                <td>{{service.is_available_queue == 1 ? 'Antrian Tersedia' : 'Antrian Tidak Tersedia'}}</td>
              </tr>
            </tbody>
          </vs-table>
        </div>
      </vs-card>
      <vs-card>
        <div slot="header">
          <h3>LIST LOKET {{service.name}}</h3>
        </div>
        <div class="flex flex-col">
          <vs-button
            @click="$router.push({name: 'services-detail-counter', params : {id : $route.params.id}})"
            color="primary"
            type="filled"
            icon-pack="feather"
            icon="icon-plus"
            class="mb-4 self-end"
            size="medium"
          >Tambah Loket</vs-button>
          <vs-table :data="counter">
            <template slot="thead">
              <vs-th>No.</vs-th>
              <vs-th>Nama Loket</vs-th>
              <vs-th>Deskripsi</vs-th>
              <vs-th>Pilihan</vs-th>
            </template>
            <template slot-scope="{data}">
              <vs-tr :data="tr" :key="indextr++" v-for="(tr, indextr) in data">
                <vs-td :data="indextr">{{ indextr }}</vs-td>
                <vs-td :data="tr.counter_name">{{ tr.counter_name }}</vs-td>
                <vs-td :data="tr.counter_description">{{ tr.counter_description }}</vs-td>
                <vs-td>
                  <div class="vx-row">
                    <vs-button
                      @click="deleteCounter(tr.id)"
                      type="border"
                      color="danger"
                      size="small"
                      class="m-1"
                      icon-pack="feather"
                      icon="icon-trash"
                    >Hapus Loket</vs-button>
                  </div>
                </vs-td>
              </vs-tr>
            </template>
          </vs-table>
        </div>
      </vs-card>
      <vs-card>
        <div slot="header">
          <h3>LIST CLUSTER </h3>
        </div>
        <div class="flex flex-col">
          <vs-button
            @click="$router.push({name: 'services-detail-cluster-create', params : {id : $route.params.id}})"
            color="primary"
            type="filled"
            icon-pack="feather"
            icon="icon-plus"
            class="mb-4 self-end"
            size="medium"
          >Tambah Cluster</vs-button>
          <vs-table :data="cluster">
            <template slot="thead">
              <vs-th>No.</vs-th>
              <vs-th>Waktu Mulai</vs-th>
              <vs-th>Waktu Selesai</vs-th>
              <vs-th>Kapasitas</vs-th>
              <vs-th>Pilihan</vs-th>
            </template>
            <template slot-scope="{data}">
              <vs-tr :data="tr" :key="indextr++" v-for="(tr, indextr) in data">
                <vs-td :data="indextr">{{ indextr }}</vs-td>
                <vs-td :data="tr.start_time">{{ tr.start_time }}</vs-td>
                <vs-td :data="tr.end_time">{{ tr.end_time }}</vs-td>
                <vs-td :data="tr.capacity">{{ tr.capacity }}</vs-td>
                <vs-td>
                  <div class="vx-row">
                    <vs-button
                      @click="$router.push({name: 'services-detail-cluster-edit', 
                              params : {id : $route.params.id, cluster_id : tr.id}})"
                      type="border"
                      color="primary"
                      size="small"
                      class="m-1"
                      icon-pack="feather"
                      icon="icon-edit"
                    >Edit Cluster</vs-button>
                    <vs-button
                      @click="deleteCluster(tr.id)"
                      type="border"
                      color="danger"
                      size="small"
                      class="m-1"
                      icon-pack="feather"
                      icon="icon-trash"
                    >Hapus Cluster</vs-button>
                  </div>
                </vs-td>
              </vs-tr>
            </template>
          </vs-table>
        </div>
      </vs-card>
      <vs-button
        @click="$router.push({name: 'services-detail', params: {id: $router.params.id}})"
        color="primary"
        type="border"
        icon-pack="feather"
        icon="icon-arrow-left"
        class="mb-4 self-end"
        size="medium"
      >Kembali</vs-button>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      service : [],
      counter : [],
      cluster : []
    };
  },
  computed: {
    
  },
  mounted() {
    this.getService();
  },
  methods: {
    deleteCounter(counter_id){
      this.$vs.loading();
      this.$http
        .post(`/app/secure/service/deleteCounter`, {
          service_id : this.$route.params.id,
          counter_id : counter_id
        })
        .then(() => {
          this.$vs.notify({
            title: "Sukses",
            text: "Berhasil menghapus loket.",
            color: "success",
            position: "top-right"
          });
          this.getService();
        })
        .catch(e => {
          this.parseError(e);
        })
        .finally(() => {
          this.$vs.loading.close();
        });
    },
    deleteCluster(cluster_id){
      this.$vs.loading();
      this.$http
        .post(`/app/secure/service/deleteCluster`, {
          service_id : this.$route.params.id,
          cluster_id : cluster_id
        })
        .then(() => {
          this.$vs.notify({
            title: "Sukses",
            text: "Berhasil menghapus cluster.",
            color: "success",
            position: "top-right"
          });
          this.getService();
        })
        .catch(e => {
          this.parseError(e);
        })
        .finally(() => {
          this.$vs.loading.close();
        });
    },
    getService() {
      this.$http
      .get(`/app/secure/service/${this.$route.params.id}/getServiceData`)
      .then(r => {
        this.service = r.data.data.service;
        this.counter = r.data.data.counter;
        this.cluster = r.data.data.cluster;
      })
      .finally(() => {
        this.$vs.loading.close();
      });
    }
  }
};
</script>>